import React, { useEffect, useState } from 'react';
import API from '../../../Utils/api';
import { useNavigate, useParams } from 'react-router';
import { useUser } from '../../../Context/useUser';
import { useVisitingUser } from '../../../Hooks/useVisitingUser';
import { FaSwimmer, FaChevronRight } from 'react-icons/fa';
import styles from './DashboardPage.module.css';

export default function ProgramsList() {
    const { user } = useUser();
    const { coachId } = useParams();
    const visitingCoach = useVisitingUser(coachId);
    // Use visitingCoach if admin is viewing a coach's dashboard, otherwise use logged-in user
    const currentCoach = coachId ? visitingCoach : user;
    const [programs, setPrograms] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (!currentCoach) return;
        console.log('Fetching programs for coach:', currentCoach._id);
        API.getMyPrograms(currentCoach._id)
            .then(({ data }) => {
                console.log('Programs response:', data);
                setPrograms(data);
            })
            .catch(err => {
                console.error('Error fetching programs:', err);
                setPrograms([]);
            });
    }, [currentCoach]);

    const handleProgramClick = () => {
        // If viewing another coach's dashboard, navigate to their programs page
        if (coachId) {
            navigate(`/coach/${coachId}/programs`);
        } else {
            navigate('/programs');
        }
    };

    return (
        <div className={styles.section}>
            <div className={styles.sectionHeader}>
                <div className={styles.sectionTitle}>
                    <FaSwimmer className={styles.sectionIcon} />
                    <h3>Programs</h3>
                </div>
                <span className={styles.badge}>{programs.length}</span>
            </div>
            <div className={styles.cardsGrid}>
                {programs.length === 0 ? (
                    <div className={styles.emptyState + ' island'}>
                        <FaSwimmer size={48} className={styles.emptyIcon} />
                        <p>No programs found.</p>
                        <small>Create programs to organize your workouts</small>
                    </div>
                ) : (
                    programs.map(program => (
                        <div
                            key={program._id}
                            className={styles.card + ' island'}
                            onClick={handleProgramClick}
                        >
                            <div className={styles.cardHeader}>
                                <FaSwimmer className={styles.cardIcon} />
                                <FaChevronRight className={styles.cardArrow} />
                            </div>
                            <div className={styles.cardContent}>
                                <h4 className={styles.cardTitle}>{program.name}</h4>
                                <p className={styles.cardDescription}>{program.type || 'Training Program'}</p>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
